import { OrderFields } from "../../../constants";
import { TOrderFormData } from "../../../models/orderForm";
import { TNewAddressForm } from "../types";

// Used to fill order data with values from newly created address

const mapAddressValuesToOrder = (address: TNewAddressForm, addressId?: string): Partial<TOrderFormData> => ({
  [OrderFields.HAS_NEW_ADDRESS]: true,
  [OrderFields.RECEIVER_ADDRESS_ID]: addressId,
  [OrderFields.RECEIVER_NAME]: address[OrderFields.NEW_ADDRESS_NAME],
  [OrderFields.RECEIVER_PHONE_NUMBER]: address[OrderFields.NEW_ADDRESS_PHONE],
  [OrderFields.RECEIVER_EMAIL]: address[OrderFields.NEW_ADDRESS_EMAIL],
  [OrderFields.RECEIVER_LOCKER]: address[OrderFields.NEW_ADDRESS_LOCKER],
  [OrderFields.RECEIVER_LOCKER_NAME]: address[OrderFields.NEW_ADDRESS_LOCKER_NAME],
  [OrderFields.RECEIVER_STREET]: address[OrderFields.NEW_ADDRESS_STREET],
  [OrderFields.RECEIVER_HOUSE_NO]: address[OrderFields.NEW_ADDRESS_HOUSE_NO],
  [OrderFields.RECEIVER_FLAT_NO]: address[OrderFields.NEW_ADDRESS_FLAT_NO],
  [OrderFields.RECEIVER_CITY]: address[OrderFields.NEW_ADDRESS_CITY],
  [OrderFields.RECEIVER_ZIP_CODE]: address[OrderFields.NEW_ADDRESS_ZIP_CODE],
});
export default mapAddressValuesToOrder;
